// `fromMcp` is a JSON string stored by the backend when a comment or task event was created
// by an AI agent through MCP: { "client": "claude-code", "ver": "1.2.3" }
// `client` is already lowercased and dash-separated by back/utils/mcpClient.js.

// Agents report free-form names in the MCP clientInfo, so recognize them by what the name
// contains rather than by an exact list. Brand marks come from the MIT licensed theSVG Color
// set (https://icon-sets.iconify.design/thesvg-color/), each in a single colour that reads on
// both themes. Unrecognized agents fall back to a generic robot icon.
function recognizeAgent(client) {
  if (client.includes('claude') && client.includes('code')) {
    return { name: 'Claude Code', icon: require('@/assets/agent_icons/claude-code.svg') };
  }
  if (client.includes('claude')) {
    return { name: 'Claude', icon: require('@/assets/agent_icons/claude.svg') };
  }
  // Codex tool calls currently reach Tracklify with Node's default `undici` user agent.
  // undici check should be removed once Codex fully complies with 2025-06-18
  if (client.includes('codex') || client.includes('openai') || client === 'undici') {
    return { name: 'Codex', icon: require('@/assets/agent_icons/codex.svg') };
  }
  if (client.includes('gemini')) {
    return { name: 'Gemini', icon: require('@/assets/agent_icons/gemini.svg') };
  }
  const name = client.split('-').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
  return { name, icon: null };
}

// Returns { label, icon } for the avatar badge, or null for human activity.
export default function describeMcpAgent(fromMcp) {
  if (!fromMcp) {
    return null;
  }

  const { client, ver } = JSON.parse(fromMcp);
  const { name, icon } = recognizeAgent(client);

  return { label: ver ? `${name} v${ver}` : name, icon };
}
